import { useEffect, useState } from 'react';
import SimpleFeedbackForm, { SimpleFeedbackFormProps } from '../SimpleFeedbackForm';
import eventBus from '../../utils/event-bus';

function TravelPlannerFeedbackFormWrapper(props: SimpleFeedbackFormProps) {
  // === STATE ===
  const [showForm, setShowForm] = useState<boolean>(false);

  useEffect(() => {
    const showFormUnsubscribe = eventBus.on('travelplannerfeedbackform:show', () => {
      setShowForm(true);
    });
    return () => {
      showFormUnsubscribe();
    };
  }, []);
  return <>{showForm && <SimpleFeedbackForm {...props} />}</>;
}

export default TravelPlannerFeedbackFormWrapper;
